import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import { DividerLooks } from '../../../../enums/divider.js';
import '../../../../styles/styled-components/alert.js';
import '../../../../styles/styled-components/animations.js';
import '../../../../styles/styled-components/box-shadow.js';
import '../../../../styles/styled-components/button.js';
import { getDividerMargin, getDividerTheme } from '../../../../styles/styled-components/divider.js';
import '../../../../themes/alert.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import { lightTheme } from '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import '../../../../styles/styled-components/font-face.js';
import '../../../../styles/styled-components/global.js';
import '../../../../styles/styled-components/input.js';
import '../../../../styles/styled-components/list.js';
import '../../../../styles/styled-components/listitem.js';
import '../../../../styles/styled-components/media-queries.js';
import '../../../../styles/styled-components/reset.js';
import '../../../../styles/styled-components/outline.js';
import '../../../../styles/styled-components/popout.js';
import '../../../../styles/styled-components/screen-reader.js';
import '../../../../styles/styled-components/switch.js';
import '../../../../styles/styled-components/tooltip.js';
import { BaseDivider } from '../base-divider/base-divider.js';

const BaseStandardDivider = (props)=>{
    const { className, look, margin, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement(BaseDivider, {
        ...otherProps,
        className: classnames({
            'bf-divider__standard': true,
            [`bf-divider__standard--look-${look}`]: !!look,
            [`bf-divider__standard--margin-${margin}`]: margin !== undefined,
            [`${className}`]: !!className
        })
    });
};
const Divider = styled(BaseStandardDivider)`
  border: 0;
  border-top-style: solid;
  border-top-width: 1px;
  display: block;
  ${({ margin })=>getDividerMargin({
        margin
    })}
  ${({ look })=>getDividerTheme({
        look
    })}
`;
/**
 * A divider (also known as a rule or separator) is a thematic break between elements, sections of content, or groups of `role="menuitem"`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/hr
 *
 * https://www.w3.org/TR/wai-aria-1.2/#separator
 *
 * @param props StandardDividerProps
 * @returns FunctionComponent<StandardDividerProps>
 */ const StandardDivider = (props)=>{
    const { look = DividerLooks.Default } = props;
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Divider, {
        ...props,
        look: look
    }));
};

export { BaseStandardDivider, StandardDivider };
//# sourceMappingURL=standard-divider.js.map
